import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { getCustomerTax } from "./ProductController"
import { Text } from "framework/validators/TextValidation"

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const ProductTaxContent = ({ DataRow, Disabled, menuCode, setarRow }) => {


  /**
      * @description This    // Check if there is any existing row with empty values
 function is used to change the value of perticular field in perticular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
      * @description This function is used to change the value of complete row.
      * @param {JSON} row - row of the table.
      * @param {string} id - id of the row.
   */

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }


  function handleAddRowNested() {
    const modifiedRows = [...DataRow];

    const hasEmptyRow = modifiedRows.find(x => x.code === "" || x.desc === "");

    if (hasEmptyRow) {
      return false;
    }

    const maxId = Math.max(...modifiedRows.map(row => row.id));

    modifiedRows.push({
      id: maxId + 1,
      code: "",
      taxCodeDisable: false,
      desc: "",
      state: true,
    });

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRow(idModification);
  }


  function handleRemoveRow(id) {
    const modifiedRows = [...DataRow];
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    modifiedRows.splice(objectIndex, 1);

    // Reassign unique IDs to the remaining rows
    for (let i = 0; i < modifiedRows.length; i++) {
      modifiedRows[i].id = i + 1;
    }

    if (modifiedRows.length === 0) {
      modifiedRows.push({
        id: 1,
        code: "",
        taxCodeDisable: false,
        desc: "",
        state: true,
      });
    }

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRow(idModification);
  }



  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"TaxmodeDet"}>
            <thead className="table-light">
              <tr>
                <th>Code </th>
                <th></th>
                <th>Description </th>
                <th style={{ textAlign: "center" }}>Is Active</th>
              </tr>
            </thead>
            <tbody disabled={true}>
              {(DataRow).map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={handleRemoveRow}
                  Disabled={Disabled}
                  menuCode={menuCode}
                  TaxColumns={[]}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                  DataRow={DataRow}
                />
              ))}
            </tbody>
          </table>
          <Button
            onClick={() => {
              handleAddRowNested()
            }}
            color="success"
            className="mt-1"
            size="sm"
            disabled={Disabled}
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default ProductTaxContent

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, menuCode, TaxColumns, changeRowValueChanges, handleObjectChange, DataRow }) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)

  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [modal_xlarge, setmodal_xlarge] = useState(false)


  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')

  const [searchdisabled, SetSearchdisabled] = useState(false)

  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //********************************************/

  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.TAX_CODE, "txtTaxcode" + Key)) {

      TaxCodeSearch(row.TAX_CODE)

    } else {
      setAlertDescription("Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
    setmodal_xlarge(!modal_xlarge)
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  async function TaxCodeSearch(value) {

    if (value == "") return

    var currentRow = FormRow

    const { success, data } = await getCustomerTax(value)

    if (success) {
      currentRow.code = data.code
      currentRow.desc = data.name
      currentRow.taxCodeDisable = true;
      handleObjectChange(currentRow, FormRow.id)
      SetSearchdisabled(true)
    } else {
      currentRow.code = ""
      currentRow.desc = ""
      currentRow.taxCodeDisable = false;
      handleObjectChange(currentRow, FormRow.id)
      setAlertDescription("Invalid code !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }

    // fetch(`${ApiURL}CustomerTax/search/${value}`, {
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/json",
    //     "Authorization": `Bearer ${authToken}`
    //   },
    // })
    //   .then(Response => Response.json())
    //   .then(responseData => {
    //     if (responseData.success == true) {

    //       const newArray = responseData.data[0]



    //     } else {

    //     }
    //   })
  }

  async function clickSearch() {
    tog_xlarge()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  // Code Validation from repeating
  const CodeValidation = (strCode, id) => {

    const filteredbyCode = DataRow.filter((item) => item.code.toLowerCase() === strCode.toLowerCase() && item.id !== FormRow.id);;

    if (filteredbyCode.length > 0) {
      return false;
    }

    return true;

  };

  return (
    <tr key={FormRow.id}>
      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtTaxcode" + Key}
              value={FormRow.code}
              onChange={e => {

                let valTax = Text(
                  e.target,
                  10,
                  true,
                  true,
                  "any",
                  false
                )

                changeRowValueChanges(valTax, FormRow.id, "code");
              }}
              onBlur={e => {
                if (CodeValidation(e.target.value, "txtTaxcode" + Key)) {
                  changeRowValueChanges(e.target.value, FormRow.id, "code");
                  TaxCodeSearch(e.target.value);
                } else {
                  setAlertDescription("Code already used");
                  setAlertConfirmOption(4);
                  setsweetAlertShow(true);
                }
                if (!e.target.value.trim()) {
                  changeRowValueChanges("", FormRow.id, "desc");
                }
                SetSearchdisabled(false);
              }}
              disabled={Disabled ? true : FormRow.taxCodeDisable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              id={"btnTaxSearch" + Key}
              onClick={clickSearch}
              disabled={Disabled ? true : FormRow.taxCodeDisable}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "400px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtTaxdesc" + Key}
              value={FormRow.desc}
              disabled={true}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <td style={{ width: "80px", margin: "auto", textAlign: "center" }}>
        <Row className="mb-0">
          <Col md="12">
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              onColor="#626ed4"
              height={23}
              handleDiameter={15}
              onChange={(e) => {
                changeRowValueChanges(e, FormRow.id, "state")
              }}
              checked={FormRow.state}
              id={"txtTaxActive" + Key}
              disabled={Disabled}
            />
          </Col>
        </Row>
      </td>

      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              color="danger"
              id={"btnFaxDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm"
              disabled={Disabled}
            >
              <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
            </Button>
          </Col>{" "}


          <DPSearchBoxDynamic
            searchData={Datatablesub}
            columns={TaxColumns}
            defaultSorted={defaultSorted}
            mainTitle={"Tax Detail Search"}
            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"TAX"}
            MenuCode={menuCode}
            KeyVal={'TAX'}
            searchBy={'TAX_CODE'}
            FilterStr={groupFilter}
          />
          <DPAlert
            confirm_both={sweetAlertShow}
            title={"Product Master !"}
            description={AlertDescription}
            showCancel={false}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              changeRowValueChanges("", FormRow.id, "code")
            }}
            btnYes={"OK"}


          />
        </Row>
      </td>
    </tr>
  )
}
